import {
    MessageReceivedEvent,
    MessageSentEvent,
    PhoneCallEvent,
    VoiceChatEvent,
    ThreadEvent,
} from "@/schemas/threadEvent.schema"

export const isMessageReceivedEvent = (
    event?: ThreadEvent
): event is MessageReceivedEvent => {
    return event?.type === "messageReceived"
}

export const isMessageSentEvent = (
    event?: ThreadEvent
): event is MessageSentEvent => {
    return event?.type === "messageSent"
}

export const isPhoneCallEvent = (
    event?: ThreadEvent
): event is PhoneCallEvent => {
    return event?.type === "phoneCall"
}

const isVoiceChatEvent = (event?: ThreadEvent): event is VoiceChatEvent => {
    return event?.type === "voiceChat"
}

export const isWilsonAuthoredThreadEvent = (event?: ThreadEvent): boolean => {
    if (isMessageSentEvent(event)) {
        return !event.data?.messaging?.sentByOperator
    }
    if (isPhoneCallEvent(event) || isVoiceChatEvent(event)) {
        return event.data?.speaker === "agent"
    }
    return false
}
